<template lang="pug">
  transition(name='modal')
    .modal-mask
      .modal-wrapper
        .modal-container(:style="{ width, height }")
          slot
</template>

<script>
export default {
  props: {
    width: String,
    height: String,
    title: String,
    background: String,
  },
}
</script>

<style lang="css" scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    margin: 0px auto;
    padding: 20px 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(.2);
    transform: scale(.2);
  }

  .modal-enter-active {
    opacity: 1;
  }

  .modal-leave {
    opacity: 1;
  }

  .modal-enter-active .modal-container,
  .modal-leave .modal-container {
    -webkit-transform: scale(5);
    transform: scale(5);
  }
</style>
